import { render } from "./InstanceInfo.vue?vue&type=template&id=48777d0a"
import script from "./InstanceInfo.vue?vue&type=script&lang=js"
export * from "./InstanceInfo.vue?vue&type=script&lang=js"

import "./InstanceInfo.vue?vue&type=style&index=0&id=48777d0a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__